module.exports = __webpack_public_path__ + "static/media/1usd.35edac85.jpg";